<template>
  <el-form
    :model="form"
    ref="form"
    class="dialog-form-default"
  >
    <!-- title -->
    <div class="row">
      <div class="col-12">
        <h3 class="blue-text">{{L10n('invoice')}}</h3>
      </div>
    </div>
    <!-- content -->
    <div class="row">
      <div class="col-lg-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('invoice-number')"
          prop="invoiceNumber"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.invoiceNumber"
            :disabled="!isNew"
            @input="form.invoiceNumber = valueTrimLeft($event)"
            @change="(value) => { $emit('onChangeInvoiceNumber', value); updateModelItem('invoiceNumber') }"
          />
        </el-form-item>
      </div>
      <div class="col-lg-8 col-sm-6 col-12">
        <el-form-item
          :label="L10n('rfq-id')"
          prop="rfqid"
          :rules="getValidationRule('required')"
          class="material-style"
          :clearable="false"
        >
          <select-response-auto-complete
            :model.sync="form.rfqid"
            @update:model="updateModelItem('rfqid', { required: true })"
            @on-change="$emit('onChangeRfq', $event)"
            api="RFQs/GetAllDynamic"
            :fields="{id: 'rfqid', title: 'rfqid'}"
            :orderBy="{fields: 'rfqid', order: 'desc'}"
            :columns="[{ title: L10n('id'), value: 'rfqid' }, { title: L10n('customer'), value: 'customerName' }, {title: L10n('rfq-type'), value: 'rfqType'}]"
            templateLabel="rfqDesc"
            templateFilter='rfqid.contains("${data.search}") || customerCompany.name.contains("${data.search}") || rfqtype.title.contains("${data.search}")'
            initTemplateFilter='${data.fields.id} == ("${data.value}")'
            selected='rfqid,rfqid.padRight(23) + customerCompany.name + " ("+ rfqtype.title +")" as rfqDesc,customerCompany.name as customerName, rfqtype.title as rfqType'
          >
          </select-response-auto-complete>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-12">
        <el-form-item
          :label="L10n('po')"
          prop="po"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.po"
            @input="form.po = valueTrimLeft($event)"
            @change="updateModelItem('po', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-sm-6 col-12">
        <el-form-item
          :label="L10n('invoice-date')"
          prop="invoiceDate"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <date-picker
            v-model="form.invoiceDate"
            @change="updateModelItem('invoiceDate', { required: true })"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-4">
            <el-form-item
              :label="L10n('invoice-due-date')"
              prop="dueDate"
              :rules="getValidationRule('required')"
              class="material-style"
            >
              <date-picker
                v-model="form.dueDate"
                @change="updateModelItem('dueDate', { required: true })"
              ></date-picker>
            </el-form-item>
          </div>
          <div class="col-auto d-flex justify-content-start align-items-center">
            <button type="button" class="btn btn-size-s" @click="onDueDateToday">
              {{L10n('due-date-today')}}
            </button>
          </div>
          <div class="col-auto">
            <el-form-item
              :label="L10n('invoice-due-date-remark')"
              class="material-style"
            >
              <el-input
                :value="dueDateRemark"
                readonly
              />
            </el-form-item>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('invoice-type')"
          prop="invoiceTypeID"
          class="material-style">
          <select-response
            :model.sync="form.invoiceTypeID"
            @update:model="updateModelItem('invoiceTypeID')"
            :isLoading="dataSourceInvoiceType.loading"
            :data="dataSourceInvoiceType.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('invoice-source')"
          prop="invoiceSourceID"
          class="material-style">
          <select-response
            :model.sync="form.invoiceSourceID"
            @update:model="updateModelItem('invoiceSourceID')"
            :isLoading="dataSourceInvoiceSource.loading"
            :data="dataSourceInvoiceSource.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('country-origin')"
          prop="countryOriginID"
          class="material-style">
          <select-response
            :model.sync="form.countryOriginID"
            @update:model="updateModelItem('countryOriginID')"
            :isLoading="dataSourceCountryOrigin.loading"
            :data="dataSourceCountryOrigin.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('vat')"
          prop="vatid"
          class="material-style">
          <select-response
            :model.sync="form.vatid"
            @update:model="updateModelItem('vatid')"
            :fields="{id: 'id', title: 'country'}"
            :isLoading="dataSourceVAT.loading"
            :data="dataSourceVAT.records"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('total-packages')"
          prop="totalPackages"
          class="material-style"
          :rules="getValidationRule('numberInteger')"
        >
          <el-input
            :value="form.totalPackages"
            @input="form.totalPackages = valueNumber($event)"
            @change="updateModelItem('totalPackages')"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('bank-fees')"
          prop="bankFees"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.bankFees"
            @input="form.bankFees = valueNumber($event)"
            @change="updateModelItem('bankFees')"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('aog-charge')"
          prop="aogCharges"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.aogCharges"
            @input="form.aogCharges = valueNumber($event)"
            @change="updateModelItem('aogCharges')"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('awb')"
          prop="awb"
          class="material-style"
        >
          <el-input
            :value="form.awb"
            @input="form.awb = valueTrimLeft($event)"
            @change="updateModelItem('awb')"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 col-12">
        <el-form-item
          :label="L10n('shipping-charges')"
          prop="shippingCharges"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.shippingCharges"
            @input="form.shippingCharges = valueNumber($event)"
            @change="updateModelItem('shippingCharges')"
          />
        </el-form-item>
      </div>
      <div class="col-sm-4 col-12">
        <el-form-item
          :label="L10n('ship-date')"
          prop="shipDate"
          class="material-style"
        >
          <date-picker
            v-model="form.shipDate"
            @change="updateModelItem('shipDate')"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-sm-4 col-12">
        <el-form-item
          :label="L10n('flight-details')"
          prop="flightDetails"
          class="material-style"
        >
          <el-input
            :value="form.flightDetails"
            @input="form.flightDetails = valueTrimLeft($event)"
            @change="updateModelItem('flightDetails')"
          />
        </el-form-item>
      </div>
      <div class="col-12">
        <el-form-item
          :label="L10n('remark')"
          prop="remark"
          class="material-style"
        >
          <el-input
            :value="form.remark"
            type="textarea"
            @input="form.remark = valueTrimLeft($event)"
            @change="updateModelItem('remark')"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { vatsDataSourceConverter } from '@/utils/shared'

export default {
  name: 'FormGeneralPayments',
  mixins: [Form],
  props: {
    isNew: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    dataSourceInvoiceSource () {
      return this.API('InvoiceSources/GetAllDynamic?Select=id,title&OrderBy=title')
    },
    dataSourceInvoiceType () {
      return this.API('InvoiceTypes/GetAllDynamic?Select=id,title&OrderBy=title')
    },
    dataSourceCountryOrigin () {
      return this.API('CountryOrigins/GetAllDynamic?Select=id,title&OrderBy=title')
    },
    dataSourceVAT () {
      return vatsDataSourceConverter(this.API('VATs/GetAllDynamic?Select=id,country&OrderBy=country'))
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourceMethod () {
      return this.API('Methods/GetAllDynamic?select=id,title')
    },
    dueDateRemark () {
      if (!this.form.dueDate) {
        return ''
      }
      const week = new Date(this.form.dueDate).getDay()
      return [0, 6].some((day) => week === day)
        ? 'invoice-due-date-change-to-weekly'
        : ''
    }
  },
  methods: {
    onDueDateToday () {
      this.form.dueDate = new Date()
      this.updateModelItem('dueDate', { required: true })
    }
  }
}
</script>
